import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelectedBoxWithPermission, useBoxContainerActions } from '../../hooks';
import { iconButtonStyle } from '../../utils/styles';
import { NavbarButton } from '../Layout/NavbarButton';
import DuotoneLightIcon from './DuotoneLightIcon';
import LabeledControlRow from './LabeledControlRow';

// `containerOnly` : force les actions sur le container même quand une box est
// sélectionnée dedans. Utilisé par la barre flottante du container (cf.
// Container.jsx) : ses boutons visent le container, quelle que soit la
// sélection. Le panel de droite, lui, appelle sans `containerOnly` — ses
// boutons restent liés à l'élément sélectionné (box ou container).
const BoxCopyDeleteButtons = ({ withLabels = false, containerOnly = false }) => {
  const { t } = useTranslation();
  const selectedBox = useSelectedBoxWithPermission();
  const { isCopyDisabled, isDeleteDisabled, copySelection, deleteSelection } = useBoxContainerActions(selectedBox, { containerOnly });

  const copyButton = (
    <NavbarButton
      tooltipContent={t('copy')}
      onClick={copySelection}
      disabled={isCopyDisabled}
      icon={<DuotoneLightIcon name='copy' style={iconButtonStyle()} />}
    />
  );
  const deleteButton = (
    <NavbarButton
      tooltipContent={t('delete')}
      onClick={deleteSelection}
      disabled={isDeleteDisabled}
      icon={<DuotoneLightIcon name='trash' className='box-delete-icon' style={{ ...iconButtonStyle(), color: !isDeleteDisabled ? '#FF0000' : 'black' }} />}
    />
  );

  if (withLabels) {
    return (
      <>
        <LabeledControlRow control={copyButton} label={t('copy')} />
        <LabeledControlRow control={deleteButton} label={t('delete')} />
      </>
    );
  }

  return (
    <>
      {copyButton}
      {deleteButton}
    </>
  );
};

export default BoxCopyDeleteButtons;
